<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="edit()">
      <v-icon color="teal">edit</v-icon>
    </v-btn>
    <span>Edit</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    edit() {
      this.$emit("edit");
    }
  }
};
</script>

<style>
</style>
